export const STOCK_ADJUSTMENT_SOURCE_TYPE_FILTER_OPTIONS = [
  { value: 'MANUAL', label: '一般' },
];

export function formatAdjustmentSourceTypeLabel(sourceType) {
  if (sourceType == null || sourceType === '') {
    return '';
  }

  const found = STOCK_ADJUSTMENT_SOURCE_TYPE_FILTER_OPTIONS.find(
    (item) => item.value === sourceType,
  );
  return found?.label ?? sourceType;
}
